export default __webpack_public_path__ + "static/media/Roboto-Bold.5e9f6556.ttf";